import { render, staticRenderFns } from "./FileAssociateDialog.vue?vue&type=template&id=1abcd4f6"
import script from "./FileAssociateDialog.vue?vue&type=script&lang=js"
export * from "./FileAssociateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports